import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OrderService } from '../../../../../../../shared/orders/order.service';

@Component({
  selector: 'app-order-detail-form',
  standalone: true,
  imports: [ReactiveFormsModule, NgSelectModule],
  templateUrl: './order-detail-form.component.html',
  styleUrl: './order-detail-form.component.scss'
})
export class OrderDetailFormComponent implements OnInit {
  @Input()
  formGroup!: FormGroup;
  @Input()
  disableEmitter!: EventEmitter<boolean>;

  temperatureTypes: string[] = [];

  constructor(private formBuilder: FormBuilder, private orderService: OrderService) { }

  ngOnInit() {
    this.disableEmitter.subscribe((value) => {
      if (value) {
        this.formGroup.disable({ emitEvent: false });
      } else {
        this.formGroup.enable();
      }
    });

    this.temperatureTypes = this.orderService.getTemperatureTypes();

    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('orderDetail', this.formBuilder.group({
      customerReference: this.formBuilder.control(""),
      orderNumber: this.formBuilder.control(""),
      temperature: this.formBuilder.control(null, [
                Validators.pattern(/^-?\d{0,3}(\.\d{0,2})?$/),
                Validators.min(-999.9),
                Validators.max(999.9)]),
      temperatureType: this.formBuilder.control(null),
      exportOrder: this.formBuilder.control(false),
      exportCertificateNumber: this.formBuilder.control(null, Validators.maxLength(30)),
      requestTruck: this.formBuilder.control("")
    }));

    this.getFormGroup().get('exportOrder')?.valueChanges.subscribe((selected) => {
      if (selected !== true) {
        this.getFormGroup().patchValue({
          requestTruck: null,
          exportCertificateNumber: null
        });
      }
    });
  }

  getFormGroup() {
    return this.formGroup.get('orderDetail') as FormGroup;
  }
}
